/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoryDto } from './categoryDto';
import { UserRoleEnum } from './userRoleEnum';
import { UserStatusEnum } from './userStatusEnum';


export interface UserResponseDto { 
    id?: number;
    name?: string | null;
    phoneNumber?: string | null;
    specialisation?: string | null;
    title?: string | null;
    approvedAt?: string | null;
    email?: string | null;
    role?: UserRoleEnum;
    profileImage?: string | null;
    createdOn?: string | null;
    phoneNumberVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    adminAccessMedCenter?: boolean | null;
    status?: UserStatusEnum;
    categories?: Array<CategoryDto> | null;
    unreadNotificationsCount?: number;
}

